import { styled } from "@acko-tech/building-blocks.ui.common";
import { AnchorLinkButton } from "@acko-tech/building-blocks.ui.button-old";

export const Wrapper = styled.div<{ isDesktop?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${props => (props.isDesktop ? "50px" : "0")};
`;

export const PolicyIcon = styled.img<{ isDesktop?: boolean }>`
  height: ${props => (props.isDesktop ? "70px" : "50px")};
  width: ${props => (props.isDesktop ? "70px" : "50px")};
`;

export const Heading = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #282e33;
  margin: 20px 0 0 0;
`;

export const Info = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #434f5a;
  margin: 20px 0 0 0;
  width: 300px;
`;

export const CTA = styled(AnchorLinkButton)`
  margin: 20px 0 0 0;

  &,
  &:hover {
    background: #37c87e;
    border: 1px solid #37c87e;
  }
`;

export const CloseIcon = styled.img`
  height: 15px;
  width: 15px;
`;
